module.exports = __webpack_public_path__ + "img/emoji_37.14d9fbfa.png";